(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sassy-sandal-picker"] && !Shopify.designMode) return;
  try {
    if (!window.sassySandalPickerInitialized) {
  window.sassySandalPickerInitialized = true;

  document.addEventListener(
    'change',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const input = event.target.closest('.sassy-color-picker input[type="radio"]');
      if (!input || !input.checked) return;

      const colorPicker = input.closest('.sassy-color-picker');
      const variantPicker = input.closest('variant-selects');
      const mapElement = colorPicker?.querySelector('[data-sassy-color-media-map]');
      const productInfo = input.closest('product-info');
      const gallery = productInfo?.querySelector('media-gallery');
      const sectionId = productInfo?.dataset.section;
      if (!variantPicker || !mapElement || !productInfo) return;

      let mediaMap;
      try {
        mediaMap = JSON.parse(mapElement.textContent);
      } catch {
        return;
      }

      const colorConfig = mediaMap[input.value];
      if (!colorConfig) return;

      const validSizes = new Set((colorConfig.sizes || []).map((size) => String(size).trim().toLowerCase()));
      const sizePicker = Array.from(
        variantPicker.querySelectorAll('fieldset.product-form__input--pill')
      ).find((fieldset) => fieldset !== colorPicker);
      const selectedSize = sizePicker?.querySelector('input[type="radio"]:checked');

      if (!selectedSize || !validSizes.has(String(selectedSize.value).trim().toLowerCase())) {
        if (selectedSize) selectedSize.checked = false;

        const replacementSize = Array.from(sizePicker?.querySelectorAll('input[type="radio"]') || []).find(
          (candidate) => validSizes.has(String(candidate.value).trim().toLowerCase())
        );
        if (replacementSize) replacementSize.checked = true;
      }

      if (
        colorConfig.mediaId &&
        gallery &&
        sectionId &&
        typeof gallery.setActiveMedia === 'function'
      ) {
        requestAnimationFrame(() => {
          gallery.setActiveMedia(`${sectionId}-${colorConfig.mediaId}`, true);
        });
      }
    },
    true
  );
}
  } catch(e) { console.error(e); }
})();

})();
